import React, { useEffect, useState, useCallback, useRef } from "react";
import Utils from "../../../utils";
import Pagination from "react-js-pagination";
import { postBillingHistory, postBillingInvoice, postBillingInvoiceDownload } from "../../../services/BilingService";
import { toast } from "react-toastify";
import Axios from "axios";
import FileDownload from "js-file-download";
import ReactToPrint from "react-to-print";
import "./Billing.css";

const lengths = Utils.tableShowLengths();

function BillingHistory() {

    const [loading, setLoading] = useState(false);

    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [list, setList] = useState([]);
    const [totalHistory, setTotalHistory] = useState(0);
    const [listProcess, setListProcess] = useState('loading...');

    const [invoiceData, setInvoiceData] = useState({});
    const [invoiceId, setInvoiceId] = useState(0);

    const [isHistory, setIsHistory] = useState(1);

    const [isPrint, setIsPrint] = useState(false);
    const componentRef = useRef(null);
    const onBeforeGetContentResolve = useRef(null);

    const handleTableLength = (e) => {
        setPage(1);
        setLimit(parseInt(e.target.value));
    };

    useEffect(function () {

        setListProcess('loading...');
        postBillingHistory({ limit: limit, page: page })
            .then(response => {
                setList(response.data.list);

                if (response.data.list.length === 0) {
                    setListProcess('No data available.');
                }

                setTotalHistory(parseInt(response.data.count));
            })
            .catch(err => {
                setListProcess('No data available.');
                toast.error(Utils.getErrorMessage(err));
            });

    }, [limit, page]);

    const handleInvoice = (e, data) => {
        e.preventDefault();

        setLoading(true);

        postBillingInvoice({ id: data.id })
            .then(response => {
                setIsHistory(0);
                setLoading(false);
                setInvoiceId(data.id);
                setInvoiceData(response.data.data);
            })
            .catch(err => {
                setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    };

    const handleBack = (e) => {
        e.preventDefault();

        setInvoiceId(0);
        setIsHistory(1);
    };

    const handleDownload = (e) => {
        e.preventDefault();

        setLoading(true);

        postBillingInvoiceDownload(invoiceId)
            .then(response => {
                Axios.get(response.data.fileUrl, {
                    responseType: 'blob',
                }).then((res) => {
                    setLoading(false);
                    FileDownload(res.data, response.data.fileName);
                }).catch(err => {
                    toast.error('Oops...something went wrong. File not found.');
                    setLoading(false);
                });
            })
            .catch(err => {
                setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    };

    useEffect(() => {
        if (isPrint === false && typeof onBeforeGetContentResolve.current === "function") {
            onBeforeGetContentResolve.current();
        }
    }, [isPrint]);

    const reactToPrintContent = useCallback(() => {
        return componentRef.current;
    }, []);

    const handleAfterPrint = useCallback(() => {

    }, []);

    const handleOnBeforeGetContent = React.useCallback(() => {
        setLoading(true);
        setIsPrint(true);

        return new Promise((resolve) => {
            onBeforeGetContentResolve.current = resolve;

            setTimeout(() => {
                setLoading(false);
                setIsPrint(false);
                resolve();
            }, 1000);
        });
    }, []);

    const handleBeforePrint = React.useCallback(() => {

  }, []);

  const reactToPrintTrigger = useCallback(() => {
    return (
      <button type="button" className="btn btn-light rounded-pill me-2 px-3 border shadow-sm"
      >
        <i className="bi bi-printer me-2"></i> Print
      </button>
    );
  }, []);

  // Helper to render the Invoice Content (DRY)
  const renderInvoiceContent = () => (
    <>
      <div className="card-header bg-white border-bottom p-5">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h1 className="fw-bold text-primary mb-0" style={{ fontSize: "2.5rem" }}>
              Docusafe
            </h1>
            <div className="text-muted mt-2 small">Tax Invoice</div>
          </div>
          <div className="text-end">
            <h4 className="text-uppercase text-secondary fw-bold mb-1">Tax Invoice</h4>
            <div className="text-muted"># {invoiceData.invoice_no}</div>
          </div>
        </div>
      </div>

      <div className="card-body p-5">
        <div className="row mb-5">
          <div className="col-sm-6 mb-4 mb-sm-0">
            <h6 className="text-uppercase text-secondary fw-bold small mb-3">Billed To</h6>
            <div className="fw-bold text-dark mb-1">
              {invoiceData.first_name} {invoiceData.last_name}
            </div>
            <div className="text-muted" style={{ maxWidth: '250px' }}>
              {invoiceData.address}
            </div>
          </div>
          <div className="col-sm-6 text-sm-end">
            <div className="row">
              <div className="col-12 mb-3">
                <h6 className="text-uppercase text-secondary fw-bold small mb-1">Order Date</h6>
                <div className="fw-medium text-dark">{invoiceData.created_at}</div>
              </div>
              <div className="col-12">
                <h6 className="text-uppercase text-secondary fw-bold small mb-1">Payment Method</h6>
                <div className="fw-medium text-dark">
                  {invoiceData.brand} <span className="text-muted">**** {invoiceData.last4}</span>
                </div>
                <div className="text-muted small">{invoiceData.email}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-5">
          <h6 className="text-uppercase text-secondary fw-bold small mb-3">Order Summary</h6>
          <div className="table-responsive">
            <table className="table table-borderless mb-0">
              <thead className="bg-light">
                <tr>
                  <th className="py-3 ps-4 text-secondary small fw-bold">No.</th>
                  <th className="py-3 text-secondary small fw-bold" style={{ width: '60%' }}>Item Description</th>
                  <th className="py-3 pe-4 text-secondary small fw-bold text-end">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-bottom">
                  <td className="ps-4 py-4">{invoiceData.invoice_no}</td>
                  <td className="py-4">
                    <div className="fw-bold text-dark mb-1">{invoiceData.plan}</div>
                    <div className="text-muted small d-flex flex-column gap-1">
                      {invoiceData.total_envelope > 0 && (
                        <span>
                          <i className="bi bi-check-circle-fill text-success me-2" />
                          {invoiceData.total_envelope} Sleeves / {invoiceData.plan_type}
                        </span>
                      )}
                      {invoiceData.total_sms > 0 && (
                        <span>
                          <i className="bi bi-check-circle-fill text-success me-2" />
                          {invoiceData.total_sms} SMS
                        </span>
                      )}
                      {invoiceData.total_user > 0 && (
                        <span>
                          <i className="bi bi-check-circle-fill text-success me-2" />
                          {invoiceData.total_user} Users
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="pe-4 py-4 text-end fw-bold text-dark fs-5">{invoiceData.paid_amount}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="2" className="text-end pt-4 pb-0">
                    <span className="text-muted me-3">Total Amount</span>
                  </td>
                  <td className="text-end pt-4 pb-0 pe-4">
                    <span className="fs-4 fw-bold text-primary">{invoiceData.paid_amount}</span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      <div className="card-footer bg-light border-top-0 p-4 text-center">
        <small className="text-muted fw-bold">Docusafe.ai</small>
      </div>
    </>
  );

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}

      <div className="billing-container">

        {/* LIST VIEW */}
        {isHistory === 1 && (
          <div className="container-fluid px-0">
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="billing-page-title">Billing History</h2>
            </div>

            <div className="billing-card">
              <div className="overflow-x-scroll">
                <table className="table billing-table mb-0">
                  <thead>
                    <tr>
                      <th className="ps-4" style={{ width: '10%' }}>Invoice</th>
                      <th style={{ width: '15%' }}>Billing Date</th>
                      <th style={{ width: '20%' }}>Plan Description</th>
                      <th style={{ width: '15%' }}>Sleeves</th>
                      <th style={{ width: '10%' }}>Users</th>
                      <th style={{ width: '15%' }}>Amount</th>
                      <th className="pe-4 text-center" style={{ width: '8%' }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list && list.map((item, index) =>
                      <tr key={index}>
                        <td className="ps-4">
                          <span className="invoice-link cursor-pointer"
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => handleInvoice(e, item)}>
                            {item.invoice_no}
                          </span>
                        </td>
                        <td>{item.created_at}</td>
                        <td>
                          <div className="fw-bold mb-1">{item.plan}</div>
                          <div className="d-flex flex-wrap">
                            {item.total_sms > 0 && (
                              <span className="plan-pill">
                                {item.total_sms} SMS
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          {item.total_envelope > 0 ? (
                            <span className="plan-pill">
                              {item.total_envelope}/{item.plan_type}
                            </span>
                          ) : "-"}
                        </td>
                        <td>
                          {item.total_user > 0 ? (
                            <span className="plan-pill">
                              {item.total_user}
                            </span>
                          ) : "-"}
                        </td>
                        <td className="amount-text">{item.paid_amount}</td>
                        <td className="pe-4 text-center">
                          <span className={`status-badge ${item.status === 'Paid' ? 'status-paid' : 'status-unpaid'}`}>
                            {item.status}
                          </span>
                        </td>
                      </tr>
                    )}

                    {list.length === 0 &&
                      <tr>
                        <td className="text-center py-5 text-muted" colSpan={7}>
                          <div className="d-flex flex-column align-items-center">
                            <i className="bi bi-inbox fs-1 mb-2 opacity-50"></i>
                            {listProcess}
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

            <div className="billing-pagination-container">
              <div className="d-flex align-items-center">
                <span className="me-2 text-light">Show</span>
                <select className="form-select show-entries-select" value={limit}
                  onChange={handleTableLength}>
                  {lengths && lengths.map((item, i) => <option value={item} key={i}>{item}</option>)}
                </select>
              </div>
              <div className="pagination-wrapper">
                <Pagination
                  activePage={page}
                  itemsCountPerPage={limit}
                  totalItemsCount={totalHistory}
                  pageRangeDisplayed={5}
                  onChange={(e) => setPage(e)}
                  itemClass="page-item"
                  linkClass="page-link"
                  prevPageText="‹"
                  nextPageText="›"
                  firstPageText="«"
                  lastPageText="»"
                />
              </div>
            </div>
          </div>
        )}

        {/* INVOICE VIEW */}
        {isHistory === 0 && (
          <div className="tab-pane active show" id="user" role="tabpanel">
            <div className="row justify-content-center">
              <div className="col-xl-9 col-lg-10">

                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h2 className="fw-bold text-white mb-0">Tax Invoice</h2>
                  <button onClick={handleBack} className="btn btn-outline-light rounded-pill px-4 bg-light text-dark">
                    <i className="bi bi-arrow-left me-2"></i> Back to History
                  </button>
                </div>

                {/* Render Logic: Print mode vs Screen mode */}

                {/* Screen Mode */}
                {isPrint === false && (
                  <div className="card border-0 shadow rounded-3 mb-4 overflow-hidden">
                    {renderInvoiceContent()}

                    {/* Action Buttons Toolbar */}
                    <div className="bg-light p-4 border-top text-end">
                      <ReactToPrint
                        content={reactToPrintContent}
                        documentTitle={invoiceData.invoice_no}
                        onAfterPrint={handleAfterPrint}
                        onBeforeGetContent={handleOnBeforeGetContent}
                        onBeforePrint={handleBeforePrint}
                        removeAfterPrint
                        trigger={reactToPrintTrigger}
                      />

                      <button type="button" className="btn btn-primary rounded-pill px-4 shadow-sm"
                        onClick={handleDownload}>
                        <i className="bi bi-download me-2"></i> Download PDF
                      </button>
                    </div>
                  </div>
                )}

                {/* Print Mode Hidden Container */}
                {isPrint === true && (
                  <div ref={componentRef} className="card border-0 mb-4">
                    {renderInvoiceContent()}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default BillingHistory;
